export function windowFactory(): Window {
  return window;
}
